import { LoginTypeEnum } from '../types'
import axiosInstance from '../utils/axiosInstance'
import { API_END_POINT } from '../utils/environment'

export const getClientByTenantId = async (token: string) => {
  return await axiosInstance.get(`${API_END_POINT.CORE}users/logged-in`, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  })
}

export const getUserLoggedInMsal = async (
  token: string,
  source?: string,
  user_type?: string
) => {
  const url = new URL(
    `${API_END_POINT.CORE}v1/users/login?action=${
      source ?? LoginTypeEnum.REFRESH
    }${user_type ? `&user_type=${user_type}` : ''}`
  )
  return axiosInstance.post(
    url.toString(),
    {},
    {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    }
  )
}

export const getLoggingActions = async (
  token: string,
  source?: string,
  user_type?: string
) => {
  try {
    const url = new URL(
      `${API_END_POINT.CORE}public/logging?action=${
        source ?? LoginTypeEnum.REFRESH
      }${user_type ? `&user_type=${user_type}` : ''}`
    )

    await axiosInstance.post(
      url.toString(),
      {},
      {
        headers: {
          Authorization: `Bearer ${token}`,
          'X-TenantId': '',
        },
      }
    )
  } catch (err) {
    console.error(err)
  }
}

export const getVersionOfApplication = async (token: string) => {
  return await axiosInstance.get(`${API_END_POINT.CORE}actuator/info`, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  })
}

export const getSiteDetails = async (token: string) => {
  return await axiosInstance.get(`${API_END_POINT.CORE}site-settings`, {
    headers: {
      Authorization: `Bearer ${token}`,
      'X-TenantId': '',
    },
  })
}

export const invalidateMsalUserToken = async () => {
  return await axiosInstance.post(
    `${API_END_POINT?.CORE}v1/users/revoke-access-token`
  )
}
